import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { CONFIG } from '../../constants/constants';
import { MensajeRespuestaDTO } from 'src/app/model/mensajeRespuestaDTO';


@Injectable({
  providedIn: 'root'
})

/**
 * Clase que se encarga de realizar la comunicación con el REST para obtener la información de acuerdo
 * a los parametros enviados por el usuario.
 */
export class RecuperarInfoService {

  constructor(private http: HttpClient) {
    this.http = http;
  }

  /**
   * Método que se encarga de realizar la consulta por tipo y número de documento.
   * @param documento 
   * @param tipoSolicitud 
   * @param tipoDocBusqueda 
   */
  public validarUsuario(documento: string, tipoSolicitud: string, tipoDocBusqueda: string): Promise<MensajeRespuestaDTO> {
    
    let _headers = new HttpHeaders({
                  'Content-Type' : 'application/json',
                  'documento' : documento,
                  'tipoSolicitud': tipoSolicitud,
                  'tipoDocBusqueda' : tipoDocBusqueda
              });

       return this.http.get<MensajeRespuestaDTO>(CONFIG.REST_END_POINT + 'recuperarInformacion/',{ headers: _headers}).toPromise();
  }

  /**
   * Método que se encarga de realizar la consulta por tipo y número de documento.
   * @param documento 
   * @param tipoSolicitud 
   * @param tipoDocBusqueda 
   */
   public validarListaDocumentos(): Promise<MensajeRespuestaDTO> {
    
    let _headers = new HttpHeaders({
                  'Content-Type' : 'application/json',
              });

       return this.http.get<MensajeRespuestaDTO>(CONFIG.REST_END_POINT + '/listarDocumentos/',{ headers: _headers}).toPromise();
  }

  /**
   * Método que se encarga de validar si el token existe o es válido.
   * @param id 
   * @param token 
   * @param userName
   */
  public validarToken(id: string, token: string, userName: string): Promise<MensajeRespuestaDTO> {

    let _headers = new HttpHeaders({
                  'Content-Type' : 'plain/text',
                  'id' : id,
                  'token': token,
                  'user': userName
              });

       return this.http.get<MensajeRespuestaDTO>(CONFIG.REST_END_POINT + 'validarToken/',{ headers: _headers}).toPromise();
  }

  /**
   * 
   * @param password Método que se encarga de realizar el cambió de contraseña luego de ingresar 
   * la misma.
   * @param id 
   */
  public cambiarContrasenia(password: string, id: string): Promise<MensajeRespuestaDTO> {
    var passwordBase64 = btoa(password);
    let _headers = new HttpHeaders({
                'Content-Type' : 'plain/text',
                'id' : id,
                'password': passwordBase64
            });

      return this.http.get<MensajeRespuestaDTO>(CONFIG.REST_END_POINT + 'cambiarContrasenia/',{ headers: _headers}).toPromise();
  }

}
